module.exports = __webpack_public_path__ + "static/media/arrowUp.c4523fcd.svg";